

































import { Vue, Component } from 'vue-property-decorator'
import Title from '@/components/PageTitle.vue'
import { Action } from 'vuex-class'
import { Step } from '../store'

@Component({
  components: {
    Title
  }
})
export default class Finish extends Vue {
  @Action('stepTo') stepTo!: Function
  private shop !: string
  created () {
    if (this.$route.query && typeof this.$route.query.shop === 'string') {
      this.shop = this.$route.query.shop
    }
  }
  mounted () {
    this.stepTo(Step.Finish)
  }
}
